import store, { modulesName } from '@/store';

const BYPASS_ROUTE_NAMES = ['signin'];
const SIGNIN_ROUTE_PATH = '/signin';

const isAuthenticated = () => {
  return store.getters[`${modulesName.userModuleName}/isLoggedIn`];
};

export const authGuard = (to, from, next) => {
  const auth = to.meta?.authorization;

  if (BYPASS_ROUTE_NAMES.includes(to.name) || !auth?.requiresAuth) {
    return next();
  }

  if (!isAuthenticated()) {
    next(SIGNIN_ROUTE_PATH);
    return;
  }

  return next();
};
